import { InjectionToken } from '@angular/core';
import { ObservableResult } from '../../models/result.model';
import {
  Ausschreibungstextes,
  Broschures, CadDatens,
  CheckDuplicateContact, FatcsStatus, ConstructionTypes,
  CreateLead, EmailData, ExtendedProperties, IAddressData,
  IContact,
  LeadData, LeadDocumentsModel,
  LeadsData, LeadsDataAction, LeadsHistory,
  LeadsQueryRequest,
  LeadSources, LeadStatus,
  LeadType, Musters, SolveDuplicateContact,
  Articles, Keyword, ImportComposerLeadResponse,
  ImportComposerLeadRequest
} from '../../models/leads/leads.model';

/** Injection token for the data service */
export const LEADS_DATA_SERVICE = new InjectionToken<LeadsDataService>('[Leads] LeadsDataService');

export interface LeadsPageInfo {
  pageNumber: number;
  pageSize: number;
  sort?: string[];
  fromDate?: string;
  toDate?: string;
}

export interface LeadsDataService {

  getLeads(onlyMyLeads: boolean, openLeads: boolean, closedLeads: boolean, unreadLeads: boolean, pageInfo: LeadsPageInfo): ObservableResult<LeadsData[]>;

  getLeadsCount(onlyMyLeads: boolean, openLeads: boolean, closedLeads: boolean, unreadLeads: boolean, pageInfo: LeadsPageInfo): ObservableResult<number>;

  queryLeads(request: LeadsQueryRequest): ObservableResult<LeadsData[]>;

  queryLeadsCount(request: LeadsQueryRequest): ObservableResult<number>;

  queryLeadsDownload(request: LeadsQueryRequest): ObservableResult<Blob>;

  addLead(body: IContact): ObservableResult<0>;

  createLead(request: CreateLead): ObservableResult<number>;

  getLeadById(leadId: number): ObservableResult<LeadData>;

  getLeadWithContactById(contactId: number): ObservableResult<LeadData[]>;

  getLeadTypes(): ObservableResult<LeadType[]>;

  getLeadStatus(): ObservableResult<LeadStatus[]>;

  getLeadSources(): ObservableResult<LeadSources[]>;

  getLeadFacts(id: number): ObservableResult<FatcsStatus[]>;

  getLeadHistory(id: number): ObservableResult<LeadsHistory[]>;

  getLeadComposerOffers(id: number): ObservableResult<any[]>;

  getLeadDocuments(id: number): ObservableResult<LeadDocumentsModel[]>;

  markAsRead(id: number): ObservableResult<void>;

  markMessageAsRead(id: number): ObservableResult<void>;

  markAsUnread(id: number): ObservableResult<void>;

  removeLeadDocument(id: number): ObservableResult<void>;

  markLeadDocument(id: number, Favorite: boolean): ObservableResult<void>;

  downloadLeadDocument(id: number): ObservableResult<Blob>;

  downloadLeadDocuments(id: number): ObservableResult<Blob>;

  downloadLeadList(): ObservableResult<Blob>;

  downloadSearchedLeadByIds(leadIds: number[]): ObservableResult<Blob>;

  downloadLead(id: number): ObservableResult<Blob>;

  updateAddress(id: number, address: IAddressData): ObservableResult<void>;

  updateCommission(id: number, commission: {[key: string]: string}): ObservableResult<void>;

  deleteAddress(id: number): ObservableResult<void>;

  deleteLead(id: number): ObservableResult<any>;

  getDuplicateLeads(): ObservableResult<any>;

  getDuplicateLeadById(leadId: number): ObservableResult<CheckDuplicateContact>;

  solveDuplicates(leadId: number, body: SolveDuplicateContact): ObservableResult<any>;

  getExtendedPropertiesByLeadId(leadId: number): ObservableResult<ExtendedProperties>;

  putExtendedPropertiesByLeadId(leadId: number, extendedProperties: ExtendedProperties): ObservableResult<ExtendedProperties>;

  getActionsById(leadId: number): ObservableResult<LeadsDataAction[]>;

  getConstructionTypes(): ObservableResult<ConstructionTypes[]>;

  importComposerLead(body: ImportComposerLeadRequest): ObservableResult<ImportComposerLeadResponse>;

  getEmailData(kkz: string): ObservableResult<EmailData>;

  addLeadArticle(id: number, article: Articles): ObservableResult<void>;

  deleteLeadArticle(id: number, articleId: number): ObservableResult<void>;

  putLeadById(id: number, constructionTypeId: number): ObservableResult<void>;

  updateHistoryComment(historyId: number, newComment: string): ObservableResult<void>;

  deleteHistoryComment(historyId: number): ObservableResult<void>;

  getBrochures(locale?: string): ObservableResult<Broschures[]>;

  getAusschreibungstextes(locale?: string): ObservableResult<Ausschreibungstextes[]>;

  getCadDatens(locale?: string): ObservableResult<CadDatens[]>;

  getMusters(locale?: string): ObservableResult<Musters[]>;

  getKeywords(leadId: number): ObservableResult<Keyword[]>;

  getAllKeywords(): ObservableResult<string[]>;

  sendKeyWords(keywords: string[], leadId: number): ObservableResult<void>;

  deleteKeywords(keywords: string[], leadId: number): ObservableResult<string[]>;
}
